import { CollectionFilter, CollectionMetaData } from '../jsonApi/BaseCollectionService';

export namespace FetchOptionsActions {

  export class UpdateFields {
    static readonly type = getActionName('Update Fields');
    constructor(readonly fields: string[]) { }
  }

  export class UpdatePageNumber {
    static readonly type = getActionName('Update PageNumber');
    constructor(readonly pageNumber: number) { }
  }

  export class UpdatePageSize {
    static readonly type = getActionName('Update PageSize');
    constructor(readonly pageSize: number) { }
  }

  export class ResetPageNumber {
    static readonly type = getActionName('Reset PageNumber');
  }

  export class UpdateTotalItems {
    static readonly type = getActionName('Update Total Items (count)');
    constructor(readonly total: number) { }
  }

  export class UpdateFilter {
    static readonly type = getActionName('Update Filter');
    constructor(readonly filter: string) { }
  }

  export class UpdateFilters {
    static readonly type = getActionName('Update Filters');
    constructor(readonly filters: CollectionFilter[]) { }
  }

  export class UpdateSortFieldName {
    static readonly type = getActionName('Update Sort Field Name');
    constructor(readonly sortFieldName: string) { }
  }

  export class UpdateSortDirection {
    static readonly type = getActionName('Update Sort Direction');
    constructor(readonly sortDirection: string) { }
  }

  export class ToDefault {
    static readonly type = getActionName('Set default');
  }

  export class SetFromResult {
    static readonly type = getActionName('Set collectionMetadata from result');
    constructor(readonly meta: CollectionMetaData) { }
  }

  export class UpdateSearch {
    static readonly type = getActionName('Update Search');
    constructor(readonly search: string) { }
  }

  function getActionName(type: string) {
    return `[FetchOptions] ${type}`;
  }
}
